import { useLanguage } from "../i18n/LanguageContext";
import { SEOHead } from "../components/SEOHead";
import { PageHeader } from "../components/PageHeader";
import { Reveal, Stagger, StaggerItem } from "../components/Reveal";
import { ContactCards } from "../components/ContactCards";
import { SmartImage } from "../components/SmartImage";
import { images } from "../config/images";

export default function About() {
  const { t } = useLanguage();
  return (
    <main data-testid="about-page">
      <SEOHead title={t.meta.about.title} description={t.meta.about.description} />
      <PageHeader eyebrow={t.aboutPage.eyebrow} title={t.aboutPage.title} crumb={t.nav.about} testId="about-header" />

      <section className="container-x grid gap-12 lg:grid-cols-12">
        <Reveal className="lg:col-span-7">
          <p className="font-display text-2xl leading-snug md:text-3xl" data-testid="about-text">{t.aboutPage.text}</p>
          <Stagger className="mt-12 grid gap-4 sm:grid-cols-3">
            {t.aboutPage.values.map((v, i) => (
              <StaggerItem key={v.title} className="rounded-3xl bg-sand-50 p-6">
                <span className="font-display text-sm text-clay">{String(i + 1).padStart(2, "0")}</span>
                <h3 className="mt-3 font-display text-xl font-medium">{v.title}</h3>
                <p className="mt-2 text-sm text-charcoal-500 leading-relaxed">{v.text}</p>
              </StaggerItem>
            ))}
          </Stagger>
        </Reveal>
        <Reveal className="lg:col-span-5" delay={0.15}>
          <SmartImage src={images.exterior} alt="Kola Pension Außenansicht – Platzhalterbild" isPlaceholder className="aspect-[4/5] rounded-[2rem] rounded-tl-[6rem]" />
        </Reveal>
      </section>

      <section className="container-x section">
        <Reveal><h2 className="h3">{t.aboutPage.contactTitle}</h2></Reveal>
        <Reveal className="mt-8" delay={0.1}><ContactCards /></Reveal>
      </section>
    </main>
  );
}
